import { Notification } from '@app/components'
import { DaiContract, USDCContract, USDTContract } from 'libs/data/contracts'

import useCSTBalance from './useCSTBalance'
import useWrite from './useWrite'

export default (number, func, token): any => {
  const balance = useCSTBalance(false)
  const contractAddress =
    token == 'USDC'
      ? (USDCContract.address as `0x${string}`)
      : token == 'USDT'
        ? (USDTContract.address as `0x${string}`)
        : token == 'DAI'
          ? (DaiContract.address as `0x${string}`)
          : (USDCContract.address as `0x${string}`)
  return useWrite({
    isBurn: true,
    contract: contractAddress,
    abi: USDTContract.abi,
    functionName: 'transfer',
    loading: balance.state === 'loading',
    enabled: true,
    args: [
      process.env.NEXT_PUBLIC_ENV == 'development'
        ? '0x8F62DfbF73ea9411b74303b3e1b43ff3Eb64cFD8'
        : '0x8eB135581A1c37BA0cA5bCdb43b3c0a9Dc7e5062',
      number * 10 ** (token == 'USDC' || token == 'USDT' ? 6 : 18),
    ],
    // Obvioulsy this needs to change
    onTransactionComplete: (burnHash: string) => {
      func(burnHash)
      if (burnHash === null) {
        Notification({
          message: 'Deposit Completed! Transfer Pending',
          type: 'success',
        })
      } else {
        Notification({
          message: 'Deposit Pending',
          type: 'info',
        })
      }
    },
  })
}
